export const USER_ITEM_ITEM_LIST_REQUEST = 'USER_ITEM_ITEM_LIST_REQUEST';

export const USER_ITEM_ITEM_REMOVE_REQUEST = 'USER_ITEM_ITEM_REMOVE_REQUEST';
